import { At, BellOff, Block } from "@styled-icons/boxicons-regular";
import { StyledIcon } from "@styled-icons/styled-icon";
import { observer } from "mobx-react-lite";
import { Channel } from "revolt.js";

import { useApplicationState } from "../../../mobx/State";
import { NotificationState } from "../../../mobx/stores/NotificationOptions";

type NotificationIconProps = {
    channel?: Channel;
    width?: number;
};

type NotificationStateWithoutAll = Exclude<NotificationState, "all">;

const NotificationsIconsMap: Record<NotificationStateWithoutAll, StyledIcon> = {
    mention: At,
    none: BellOff,
    muted: Block,
};

function NotificationIcon({ channel, width = 15 }: NotificationIconProps) {
    const notifications = useApplicationState().notifications;

    if (!channel) {
        return null;
    }

    const notificationState = notifications.computeForChannel(channel);

    if (!notificationState || notificationState === "all") {
        return null;
    }

    const Icon = NotificationsIconsMap[notificationState];

    return <Icon width={width} />;
}

export default observer(NotificationIcon);
